// src/components/CreatePromoCodeForm.js
import React, { useState } from 'react';
import { createPromoCode } from '../services/api';

export default function CreatePromoCodeForm({ onCodeCreated }) {
  const [code, setCode] = useState('');
  const [points, setPoints] = useState('');
  const [usesLeft, setUsesLeft] = useState('');
  const [expiresAt, setExpiresAt] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('Создание...');
    try {
      await createPromoCode({
        code,
        points,
        usesLeft: usesLeft || null, // Отправляем null, если поле пустое
        expiresAt: expiresAt || null,
      });
      setMessage(`Код ${code.toUpperCase()} создан!`);
      onCodeCreated(); // Обновляем список
    } catch (error) {
      setMessage(error.response?.data?.error || 'Ошибка');
    }
  };

  return (
    <div className="create-promocode-form">
      <h6>Создать промокод</h6>
      <form onSubmit={handleSubmit}>
        <input type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="Код (HELLO)" required/>
        <input type="number" value={points} onChange={e => setPoints(e.target.value)} placeholder="Очки (100)" required/>
        <input type="number" value={usesLeft} onChange={e => setUsesLeft(e.target.value)} placeholder="Лимит использований (опц.)"/>
        <input type="date" value={expiresAt} onChange={e => setExpiresAt(e.target.value)} placeholder="Истекает (опц.)"/>
        <button type="submit">Создать</button>
      </form>
      {message && <p className="form-message">{message}</p>}
    </div>
  );
}